import { useTrackedQuery } from "@/hooks/apollo-insights-hooks";
import { QUERY_CITY_LIST } from "@/services/web/api-cities.const";

export const useCities = () => {
  const { data, error, loading } = useTrackedQuery(QUERY_CITY_LIST, {
    actionName: "QueryCityList",
  });
  const cities = data?.cities ?? [];

  return { cities, loading, error };
};
